import { useContext } from "react";
import { Redirect, Route } from "react-router-dom";

// import { FadeInt3Div } from "../../../../styledComponents/animation";
import TourGuide_joyride from "common/components/TourGuide_joyride";
import Permission from "common/context/Permission/Permission";
import Layout2 from "modules/layout2";
import auth from "modules/login/login/login/auth";
import { RouteContext } from "routes";

export default function Index({
  component: Component,
  withoutAuth: withoutAuth,
  ...rest
}) {
  const { setPath } = useContext(RouteContext);
  const { isAuthenticated } = auth();

  return (
    <>
      <Route
        {...rest}
        render={(props) => {
          if (isAuthenticated || withoutAuth) {
            return (
              <>
                <TourGuide_joyride>
                  <Permission>
                    <Layout2>
                      <Component {...props} />
                    </Layout2>
                  </Permission>
                </TourGuide_joyride>
              </>
            );
          } else {
            setPath(window.location.pathname);
            sessionStorage.setItem("redirectpath", window.location.pathname);

            return <Redirect to={"/auth"} />;
          }
        }}
      />
    </>
  );
}
